import WithRender from "../../templates/base/preview2D.html";

import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getPreview2D"])
  },
  props: ["visible"]
});
